import { CircularProgress, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSubscriptionContext } from "@context/SubscriptionContext";
import SubscriptionCard from "@components/Subscriptions/SubscriptionCard";
import PremiumUpgradeComponent from "@components/Subscriptions/PremiumUpgradeComponent";
import EnablePremiumAutoRenewalBanner from "@components/Subscriptions/EnablePremiumAutoRenewalBanner";
import { useContext } from "react";
import { UserContext } from "@context/UserContext";
import { SUBSCRIPTION_PRODUCT_TYPES, SUBSCRIPTION_STATUSES, SUBSCRIPTION_SOURCES } from "@constants/subscriptions";
import { deriveSubscriptionStatus } from "@utils/getSubscriptionDisplayInformation";

const SubscriptionsContainer = () => {
  const { t } = useTranslation();
  const { subscriptions, areSubscriptionsLoading, error, shouldShowPremiumUpgradeModal } = useSubscriptionContext();
  const { user, isUserLoading } = useContext(UserContext);

  if (areSubscriptionsLoading || isUserLoading) {
    return (
      <Box className="flex justify-center py-8">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" variant="body2">
        {t("Error loading data")}
      </Typography>
    );
  }
  return (
    <Box
      data-testid="subscriptions-container"
    >
      {shouldShowPremiumUpgradeModal && user && <PremiumUpgradeComponent user={user} />}
      {subscriptions.map((sub) => (
        <Box key={sub.id}>
          {sub.subscriptionType === SUBSCRIPTION_PRODUCT_TYPES.SELF_PAID_PREMIUM
            && deriveSubscriptionStatus(sub) === SUBSCRIPTION_STATUSES.CANCELLED
            && sub.source !== SUBSCRIPTION_SOURCES.APPLE
            && sub.source !== SUBSCRIPTION_SOURCES.GOOGLE && (
            <EnablePremiumAutoRenewalBanner subscription={sub} />
          )}
          <SubscriptionCard subscription={sub} />
        </Box>
      ))}
    </Box>
  );
};

export default SubscriptionsContainer;
